export class Market {
  public orgType: string;
  public salesDivision: string;

  constructor(orgType: string, salesDivision: string) {
    this.orgType = orgType;
    this.salesDivision = salesDivision;
  }
}
